// import { useMemo } from 'react';
// import {
//   useTable,
//   useSortBy,
//   useGlobalFilter,
//   usePagination,
//   Column,
// } from 'react-table';
// import Pagination from './Pagination';
// import { CustomColumn } from '../../types/customColumn';
// import IconButtonActions from './IconButtonActions';

// const DataTable = <T extends object>({
//   columns,
//   data,
//   actions,
//   pageSizeOptions,
//   headerButton,
//   documentDropdown,
//   url,
//   paginator,
//   searchComponent,
//   onPageSizeChange,
//   noDataMessage = 'No hay registros disponibles.', // Nuevo prop con mensaje por defecto
// }: {
//   columns: Column<T>[];
//   data: any[];
//   actions?: any;
//   pageSizeOptions: number[];
//   headerButton?: JSX.Element;
//   documentDropdown?: JSX.Element;
//   url?: string;
//   paginator?: any;
//   searchComponent?: JSX.Element;
//   onPageSizeChange: (size: number) => void;
//   noDataMessage?: string; // Nuevo prop para personalizar el mensaje cuando no hay datos
// }) => {
//   const memoizedData = useMemo(() => data, [data]);

//   const tableInstance = useTable(
//     {
//       columns: columns as readonly Column<any>[],
//       data: memoizedData,
//       initialState: { pageIndex: 0 },
//     },
//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   );

//   const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
//     tableInstance;

//   return (
//     <section className="data-table-common data-table-two rounded-sm border border-stroke bg-white py-4 shadow-default dark:border-strokedark dark:bg-boxdark">
//       {(headerButton || documentDropdown) && (
//         <div className="flex flex-wrap justify-between gap-4 border-b border-stroke px-4 pb-4 dark:border-strokedark md:px-8">
//           {headerButton && <div>{headerButton}</div>}
//           {documentDropdown && <div>{documentDropdown}</div>}
//         </div>
//       )}

//       <div className="flex flex-wrap justify-between gap-4 border-b border-stroke px-4 pb-4 pt-4 dark:border-strokedark md:px-8">
//         <div className="w-full md:w-1/3">{searchComponent}</div>
//         <div className="flex items-center gap-4">
//           <div className="flex items-center font-medium">

//             <div className="relative">
//               <select
//                 onChange={(e) => onPageSizeChange(Number(e.target.value))}
//                 className="text-gray-700 appearance-none rounded-md border-[1.5px] border-stroke bg-white px-5 py-2.5 pl-4 pr-10 outline-none focus:border-primary dark:border-strokedark dark:bg-meta-4 dark:focus:border-primary"
//               >
//                 {pageSizeOptions.map((size) => (
//                   <option key={size} value={size} className="text-black">
//                     {size}
//                   </option>
//                 ))}
//               </select>
//               {/* Icono SVG en la esquina derecha */}
//               <div className="pointer-events-none absolute inset-0 left-auto right-4 flex items-center">
//                 <svg
//                   width="18"
//                   height="18"
//                   viewBox="0 0 18 18"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M9.0002 12.8249C8.83145 12.8249 8.69082 12.7687 8.5502 12.6562L2.08145 6.2999C1.82832 6.04678 1.82832 5.65303 2.08145 5.3999C2.33457 5.14678 2.72832 5.14678 2.98145 5.3999L9.0002 11.278L15.0189 5.34365C15.2721 5.09053 15.6658 5.09053 15.9189 5.34365C16.1721 5.59678 16.1721 5.99053 15.9189 6.24365L9.45019 12.5999C9.30957 12.7405 9.16895 12.8249 9.0002 12.8249Z"
//                     fill="#64748B"
//                   />
//                 </svg>
//               </div>
//             </div>

//             <p className="pl-2 text-gray-700 dark:text-white">
//               Entradas por página
//             </p>
//           </div>
//         </div>
//       </div>

//       <div className="w-full overflow-x-auto">
//         <table
//           {...getTableProps()}
//           className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
//         >
//           <thead>
//             {headerGroups.map((headerGroup) => (
//               <tr
//                 {...headerGroup.getHeaderGroupProps()}
//                 className="bg-gray-100 dark:bg-gray-800"
//               >
//                 {headerGroup.headers.map((column) => (
//                   <th
//                     {...column.getHeaderProps(column.getSortByToggleProps())}
//                     className="text-gray-800 dark:text-gray-200 px-5 py-4 text-left text-sm font-semibold sm:text-base"
//                   >
//                     <div className="flex items-center">
//                       {column.render('Header')}
//                       <div className="ml-2 inline-flex flex-col space-y-[2px]">
//                         <span className="inline-block">
//                           <svg
//                             className="fill-current"
//                             width="10"
//                             height="5"
//                             viewBox="0 0 10 5"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path d="M5 0L0 5H10L5 0Z" />
//                           </svg>
//                         </span>
//                         <span className="inline-block">
//                           <svg
//                             className="fill-current"
//                             width="10"
//                             height="5"
//                             viewBox="0 0 10 5"
//                             xmlns="http://www.w3.org/2000/svg"
//                           >
//                             <path d="M5 5L10 0L-4.37114e-07 8.74228e-07L5 5Z" />
//                           </svg>
//                         </span>
//                       </div>
//                     </div>
//                   </th>
//                 ))}
//                 {actions && (
//                   <th className="min-w-[120px] text-center">
//                     <span className="flex justify-center">Acciones</span>
//                   </th>
//                 )}
//               </tr>
//             ))}
//           </thead>
//           <tbody {...getTableBodyProps()}>
//             {page.length > 0 ? (
//               page.map((row) => {
//                 prepareRow(row);
//                 return (
//                   <tr
//                     {...row.getRowProps()}
//                     className="dark:border-gray-700 border-b"
//                   >
//                     {row.cells.map((cell) => {
//                       const column = cell.column;
//                       return (
//                         <td
//                           {...cell.getCellProps()}
//                           className="text-gray-900 dark:text-gray-200 px-4 py-2 text-sm"
//                         >
//                           {'customCell' in column &&
//                           (column as CustomColumn<object>).customCell
//                             ? (column as CustomColumn<object>).customCell(cell)
//                             : cell.render('Cell')}
//                         </td>
//                       );
//                     })}
//                     {actions && (
//                       <td className="px-4 py-2 text-center">
//                         <div className="flex justify-center">
//                           <IconButtonActions
//                             actions={actions}
//                             row={row.original}
//                           />
//                         </div>
//                       </td>
//                     )}
//                   </tr>
//                 );
//               })
//             ) : (
//               <tr>
//                 <td
//                   colSpan={columns.length + (actions ? 1 : 0)}
//                   className="text-gray-600 dark:text-gray-300 py-4 text-center"
//                 >
//                   {noDataMessage}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//       <Pagination url={url} paginator={paginator} />
//     </section>
//   );
// };

// export default DataTable;

import { useMemo } from 'react';
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
  Column,
} from 'react-table';
import DataTableHeader from './DataTableHeader';
import DataTableHead from './DataTableHead';
import DataTableBody from './DataTableBody';
import DataTableEmpty from './DataTableEmpty';
import DataTablePagination from './DataTablePagination';

interface DataTableProps<T extends object> {
  columns: Column<T>[];
  data: T[];
  actions?: any;
  pageSizeOptions: number[];
  headerButton?: JSX.Element;
  documentDropdown?: JSX.Element;
  url?: string;
  paginator?: any;
  searchComponent?: JSX.Element;
  onPageSizeChange: (size: number) => void;
  noDataMessage?: string;
}

const DataTable = <T extends object>({
  columns,
  data,
  actions,
  pageSizeOptions,
  headerButton,
  documentDropdown,
  url,
  paginator,
  searchComponent,
  onPageSizeChange,
  noDataMessage = 'No hay registros disponibles.',
}: DataTableProps<T>) => {
  const memoizedData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: columns as readonly Column<any>[],
      data: memoizedData,
      initialState: { pageIndex: 0 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, headerGroups, page, prepareRow } =
    tableInstance;

  return (
    <section className="data-table-common data-table-two rounded-sm border border-stroke bg-white py-4 shadow-default dark:border-strokedark dark:bg-boxdark">
      <DataTableHeader
        headerButton={headerButton}
        documentDropdown={documentDropdown}
        searchComponent={searchComponent}
        pageSizeOptions={pageSizeOptions}
        onPageSizeChange={onPageSizeChange}
      />

      <div className="w-full overflow-x-auto">
        <table
          {...getTableProps()}
          className="datatable-table w-full min-w-[700px] table-auto border-collapse break-words md:table-fixed md:overflow-auto"
        >
          <DataTableHead headerGroups={headerGroups} actions={actions} />
          {page.length > 0 ? (
            <DataTableBody
              page={page}
              prepareRow={prepareRow}
              columns={columns}
              actions={actions}
            />
          ) : (
            <DataTableEmpty columns={columns} actions={actions} message={noDataMessage} />
          )}
        </table>
      </div>

      <DataTablePagination url={url} paginator={paginator} />
    </section>
  );
};

export default DataTable;
